import { useCallback, useEffect, useState } from 'react'

export type CenterModalDataListType = {
	title?: string
	desc: string
	zIndex?: number
}

export type UseCenterModalReturn = {
	centerModalVisible: boolean
	centerModalContent: CenterModalDataListType
	openCenterModal: (
		content: CenterModalDataListType,
		completeCallback: () => void,
		cancelCallback?: () => void,
	) => void
	closeCenterModal: () => void
	onCenterModalComplete: () => void
	onCenterModalCancel: () => void
}

const useCenterModal = () => {
	const [centerModalVisible, setCenterModalVisible] = useState<boolean>(false)
	const [centerModalContent, setCenterModalContent] = useState<CenterModalDataListType>({
		title: undefined,
		desc: '',
	})
	const [onCenterModalComplete, setOnCenterModalComplete] = useState<() => void>(() => {})
	const [onCenterModalCancel, setOnCenterModalcancel] = useState<() => void>(() => {})

	const openCenterModal = useCallback(
		(
			content: CenterModalDataListType,
			completeCallback: () => void,
			cancelCallback?: () => void,
		) => {
			setCenterModalVisible(true)
			setCenterModalContent(content)
			setOnCenterModalComplete(completeCallback)
			if (cancelCallback) {
				setOnCenterModalcancel(cancelCallback)
			}
		},
		[],
	)

	const closeCenterModal = useCallback(() => {
		setCenterModalVisible(false)
		setCenterModalContent({ title: '', desc: '' })
		setOnCenterModalComplete(() => {})
		setOnCenterModalcancel(() => {})
	}, [])

	useEffect(() => {
		//
	}, [])

	return {
		centerModalVisible,
		centerModalContent,
		onCenterModalComplete,
		onCenterModalCancel,
		openCenterModal,
		closeCenterModal,
	}
}

export default useCenterModal
